<div class="modal-overlay" *ngIf="showModalFeedback" (click)="!salvando && fecharModal()">
  <div class="box-novo-compromisso" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold"><i class="fa fa-comment"></i> Feedback</h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close" [disabled]="salvando"></button>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-md-12">
        <div class="form-group">
          <textarea class="form-control" name="texto" id="texto" rows="5"
                    [(ngModel)]="feedback.texto" placeholder="Digite sua sugestão e/ou feedback"
                    [disabled]="salvando"> </textarea>
        </div>
      </div>
      <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-light" (click)="fecharModal()" [disabled]="salvando">Cancelar</button>
        <button type="button" class="btn btn-success px-4 d-flex align-items-center gap-2" (click)="salvarFeedback()" [disabled]="salvando || !feedback.texto">
          <span *ngIf="salvando" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          {{ salvando ? 'Salvando...' : 'Salvar' }}
        </button>
      </div>
    </div>
  </div>
</div>
